module.exports = __webpack_public_path__ + "static/Ethic-1f210c9eb171536fabfda78307cfc437.jpg";